import React, { useEffect, useContext, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes, ToastContext } from '../../../contexts';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DateTime } from '../../../common';
import {
  Paper,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Hidden,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  InputLabel,
  Grid,
  LinearProgress,
  TableFooter
} from '@material-ui/core';
import * as moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import { ApplicationRoles } from '../../../../helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflowX: "initial"
  },
  author: {
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word'
  },
  avatar: {
    marginRight: theme.spacing(1)
  },
  table: {

  },
  header: {
    fontSize: '1rem'
  }
}));

export default function MilestonesDialog(props) {
  const { showErrorMessage } = useContext(ToastContext);
  const { fetchAuthorized } = useContext(FetchContext);
  const classes = useStyles();

  const [isDialog, setIsDialog] = useState(false);
  const [allMilestones, setAllMilestones] = useState(null);
  const [currentMilestone, setCurrentMilestone] = useState(null);
  const [availablePms, setAvailablePms] = useState(null);
  const [milestoneId, setMilestoneId] = useState(null);
  const [title, setTitle] = useState(null);
  const [businessOwner, setBusinessOwner] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [value, setValue] = useState(0);
  const [phase, setPhase] = useState(null);
  const [status, setStatus] = useState(null);
  const [progress, setProgress] = useState(0);
  const [notes, setNotes] = useState(null);
  const [projectManager, setProjectManager] = useState(null);
  const [userName, setUserName] = useState(null);
  const [canUser, setCanUser] = useState(false);
  const [isLoadingMilestones, setIsLoadingMilestones] = useState(false);
  const [isSavingMilestones, setIsSavingMilestones] = useState(false);
  const [isDeletingMilestones, setIsDeletingMilestones] = useState(null);
  const [totalValue, setTotalValue] = useState(0);

  const getMilestonesAsync = async () => {
    setIsLoadingMilestones(true);
    const getMilestonesApi = await fetchAuthorized(ApiRoutes.Projects.GetMilestones({ projectId: props.selectedProject[0].id, pageSize: 1000 }),
      {
        method: HttpMethods.GET
      });

    const allMilestones = await getMilestonesApi.json();

    if (allMilestones && allMilestones.items && allMilestones.items.length > 0){
      let allValues = 0;
      allMilestones.items.map(milestone => allValues += milestone.value);
      setTotalValue(allValues);
    }

    setAllMilestones(allMilestones);
    setIsLoadingMilestones(false);
  }

  const getMilestoneAsync = async (data) => {
    const getMilestoneApi = await fetchAuthorized(ApiRoutes.Projects.GetMilestone({ milestoneId: data }),
      {
        method: HttpMethods.GET
      });

    const currentMilestone = await getMilestoneApi.json();
    setCurrentMilestone(currentMilestone);
  }

  const getProjectManagersAsync = async () => {
    const getProjectManagersApi = await fetchAuthorized(ApiRoutes.User.GetMyProjectTeam(),
      {
        method: HttpMethods.GET
      });

    const pmsOwner = await getProjectManagersApi.json();
    setAvailablePms(pmsOwner);
  }

  const currencyFormatter = (params) => {
    const formatter = new Intl.NumberFormat('en-US', {//it-IT
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });

    return formatter.format(params);
  }

  useEffect(() => {
    if (isDialog)
      getMilestonesAsync();

    if (props.isUserInRoles([ApplicationRoles.Owner]))
      getProjectManagersAsync();
  }, [isDialog])

  useEffect(() => {
    if (milestoneId)
      getMilestoneAsync(milestoneId);
  }, [milestoneId])

  useEffect(() => {
    if (currentMilestone !== null) {
      setTitle(currentMilestone.title);
      setBusinessOwner(currentMilestone.businessOwner);
      setStartDate(dateConverterToLocal(currentMilestone.startDate));
      setEndDate(dateConverterToLocal(currentMilestone.endDate));
      setValue(currentMilestone.value);
      setPhase(currentMilestone.phaseId);
      setStatus(currentMilestone.statusId);
      setProgress(currentMilestone.progress);
      setNotes(currentMilestone.notes);
      setProjectManager(currentMilestone.projectManagerKey);
      setUserName(currentMilestone.projectManagerFullName);
    }
  }, [currentMilestone])

  useEffect(() => {
    if (props.errorMilestone !== null) {
      if (props.errorMilestone === false) {
        resetFields();
        getMilestonesAsync();
      }
    }
  }, [props.errorMilestone])

  function checkPM(milestone) {
    if (props && props.isEditable && props.selectedProject && props.selectedProject[0] &&
      (
        (
          props.isUserInRoles([ApplicationRoles.Owner]) &&
          (
            props.currentUser.externalKey === props.selectedProject[0].ownerKey ||
            props.currentUser.externalKey === milestone.projectManagerKey
          )
        ) ||
        (
          props.isUserInRoles([ApplicationRoles.ProjectManager]) &&
          props.currentUser.externalKey === milestone.projectManagerKey
        )
      )
    )
      return true;
      
    return false;
  }

  function dateConverterToLocal(milestoneDate) {
    const checkDate = milestoneDate.indexOf('Z') !== -1 ? milestoneDate : milestoneDate + "Z";
    const date = new Date(checkDate);
    return moment(date).format("YYYY-MM-DD");
  }

  function dateConverterToUTC(milestoneDate) {
    const lastSecond = new Date().setSeconds(59);
    const lastSecondDate = new Date(lastSecond);
    const date = new Date(milestoneDate);
    const nowUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), lastSecondDate.getUTCHours(), lastSecondDate.getUTCMinutes(), lastSecondDate.getUTCSeconds());
    return new Date(nowUtc);
  }

  function getPhaseLabel(phaseId) {
    let label = null;
    if (props && props.phaseOptions && props.phaseOptions.length > 0)
      props.phaseOptions.map(phaseObject => {
        if (phaseId === phaseObject.id)
          label = phaseObject.title;
      });
    return label;
  }

  function resetFields() {
    setMilestoneId(null);
    setTitle(null);
    setBusinessOwner(null);
    setStartDate(null);
    setEndDate(null);
    setValue(0);
    setPhase(null);
    setStatus(null);
    setProgress(0);
    setNotes(null);
    setProjectManager(null);
    setUserName(null);
    setTotalValue(0);
  }

  function closeDialog() {
    resetFields();
    setAllMilestones(null);
    setIsDialog(false);
  }

  return (
    <span>
      <Button
        color="primary"
        size="small"
        variant="contained"
        style={{ marginRight: '15px', fontSize: '11px' }}
        onClick={() => setIsDialog(true)}
        disabled={
          !props.selectedProject ||
          props.selectedProject.length !== 1 ||
          !props.selectedProject[0].id
        }
      >Milestones</Button>
      <Dialog
        open={isDialog}
        onClose={() => closeDialog()}
        aria-labelledby="form-dialog-title"
      >
        {isLoadingMilestones ?
          <LinearProgress color="primary" style={{ margin: '15px 20px' }} /> :
          <>
            {
              (milestoneId || milestoneId === 0) &&
              <DialogTitle id="form-dialog-title" style={{ fontSize: '22px', height: '15%', display: 'flex', justifyContent: 'center' }}>Milestone</DialogTitle>
            }
            <DialogContent style={{ margin: '0px 30px', height: '85%' }}>
              {
                milestoneId || milestoneId === 0 ?
                  <>
                    <Grid container spacing={3} style={{ height: '80%' }}>
                      <Grid item xs={12}>
                        <TextField
                          label="Title*"
                          variant="outlined"
                          style={{ display: "flex" }}
                          value={title ? title : ""}
                          onChange={event => {
                            event.persist();
                            setTitle(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={6}>
                        {
                          props.isEditable &&
                          props.isUserInRoles([ApplicationRoles.Owner]) &&
                          props.selectedProject[0].ownerKey === props.currentUser.externalKey
                          ?
                          <TextField
                            select
                            label="Project manager*"
                            style={{ display: "flex" }}
                            variant="outlined"
                            value={projectManager ? projectManager : ""}
                            onChange={x => setProjectManager(x.target.value)}
                            disabled={!props.isEditable || !canUser}
                          >
                            {availablePms &&
                            availablePms.projectManagers &&
                            availablePms.projectManagers.length > 0 &&
                            availablePms.projectManagers.map((pm, index) =>
                              <MenuItem value={pm.userKey} key={index}>
                                {pm.displayName}
                              </MenuItem>
                            )}
                          </TextField> :
                          <TextField
                            label="Project manager*"
                            variant="outlined"
                            style={{ display: "flex" }}
                            value={userName ? userName : props && props.currentUser && props.currentUser.displayName}
                            disabled={true}
                          />
                        }
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Business owner*"
                          variant="outlined"
                          style={{display: "flex"}}
                          //inputProps={{min: 0, style: { textAlign: 'center' }}}
                          value={businessOwner ? businessOwner : ""}
                          onChange={event => {
                            event.persist();
                            setBusinessOwner(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          select
                          label="Phase*"
                          style={{ display: "flex"}}
                          variant="outlined"
                          value={phase ? phase : ""}
                          onChange={x => setPhase(x.target.value)}
                          disabled={!props.isEditable || !canUser}
                        >
                          {props.phaseOptions &&
                          props.phaseOptions.length > 0 &&
                          props.phaseOptions.map((phaseObject, index) =>
                            <MenuItem value={phaseObject.id} key={index}>
                              {phaseObject.title}
                            </MenuItem>
                          )}
                        </TextField>
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          select
                          label="Status*"
                          style={{ display: "flex"}}
                          variant="outlined"
                          value={status ? status : ""}
                          onChange={x => setStatus(x.target.value)}
                          disabled={!props.isEditable || !canUser}
                        >
                          {props.statusOptions &&
                          props.statusOptions.length > 0 &&
                          props.statusOptions.map((statusObject, index) =>
                            <MenuItem value={statusObject.id} key={index}>
                              {statusObject.title}
                            </MenuItem>
                          )}
                        </TextField>
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          style={{ display: 'flex' }}
                          label="Start date*"
                          type="date"
                          variant="outlined"
                          value={startDate ? startDate : ""}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={event => {
                            event.persist();
                            setStartDate(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          style={{ display: 'flex' }}
                          label="End date*"
                          type="date"
                          variant="outlined"
                          value={endDate ? endDate : ""}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={event => {
                            event.persist();
                            setEndDate(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="description" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          style={{ display: 'flex' }}
                          variant="outlined"
                          label="Value €*"
                          //inputProps={{min: 0, style: { textAlign: 'center' }}}
                          value={value || value === 0 ? value : ""}
                          onChange={event => {
                            event.persist();
                            setValue(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="name" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          style={{ display: 'flex' }}
                          label="Progress %*"
                          variant="outlined"
                          //inputProps={{min: 0, style: { textAlign: 'center' }}}
                          value={progress || progress === 0 ? progress : ""}
                          onChange={event => {
                            event.persist();
                            setProgress(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="description" errors={errors} /> */}
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          style={{ display: "flex" }}
                          label="Notes*"
                          variant="outlined"
                          multiline
                          rowsMax="3"
                          //inputProps={{min: 0, style: { textAlign: 'center' }}}
                          value={notes ? notes : ""}
                          onChange={event => {
                            event.persist();
                            setNotes(event.target.value);
                          }}
                          disabled={!props.isEditable || !canUser}
                        />
                        {/* <FieldError name="description" errors={errors} /> */}
                      </Grid>
                    </Grid>
                    <DialogActions style={{ display: 'flex', justifyContent: 'center', height: '20%' }}>
                      {
                        props.isEditable &&
                        (
                          props.isUserInRoles([ApplicationRoles.Owner]) ||
                          (
                            props.isUserInRoles([ApplicationRoles.ProjectManager]) && canUser
                          )
                        ) &&
                        <>
                          {
                            isSavingMilestones ?
                              <CircularProgress color="primary" /> :
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ fontSize: '12px', marginRight: '20px', alignSelf: 'flex-end' }}
                                onClick={() => {
                                  if (
                                    props.isUserInRoles([ApplicationRoles.Owner]) &&
                                    props.selectedProject[0].ownerKey === props.currentUser.externalKey &&
                                    !projectManager
                                  )
                                    showErrorMessage("Enter each field to continue");

                                  else if (title && businessOwner && startDate && endDate && (value === "0" || value === 0 || Number(value)) && Number(phase) && Number(status) && (progress === "0" || progress === 0 || Number(progress)) && notes) {
                                    if (String(progress).indexOf('.') !== -1 || Number(progress) < 0 || Number(progress) > 100)
                                      showErrorMessage("progress must be an integer within the range 0 - 100");

                                    else {
                                      sendDataAsync();

                                      async function sendDataAsync() {
                                        const newMilestone = {
                                          milestoneId: milestoneId,
                                          projectId: props.selectedProject[0].id,
                                          title: title,
                                          projectManagerKey: props.isUserInRoles([ApplicationRoles.Owner]) ? projectManager : props.currentUser.externalKey,
                                          businessOwner: businessOwner,
                                          startDate: dateConverterToUTC(startDate),
                                          endDate: dateConverterToUTC(endDate),
                                          phaseId: Number(phase),
                                          statusId: Number(status),
                                          value: Number(value),
                                          progress: Number(progress),
                                          notes: notes
                                        };

                                        setIsSavingMilestones(true);
                                        await props.saveMilestoneAsync(newMilestone);
                                        setIsSavingMilestones(false);
                                      }
                                    }
                                  }

                                  else
                                    showErrorMessage("Enter each field to continue");
                                }}
                              >
                                Save
                      </Button>
                          }
                        </>
                      }
                      {
                        !isSavingMilestones &&
                        <Button
                          variant="contained"
                          style={{ fontSize: '12px', alignSelf: 'flex-end' }}
                          onClick={() => resetFields()}
                        >
                          Cancel
                  </Button>
                      }
                    </DialogActions>
                  </> :
                  <div style={{ height: '100%' }}>
                    <div style={{ height: '85%', overflowY: 'auto' }}>
                      <TableContainer className={classes.root}>
                        <Table className={classes.table} arial-label="role table" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell className={classes.header} align="left">
                                Milestone
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                Project manager
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                Start date
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                End Date
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                Phase
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                Value
                              </TableCell>
                              <TableCell align="right"></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allMilestones &&
                              allMilestones.items &&
                              allMilestones.items.length > 0 &&
                              allMilestones.items.map((milestone, index) =>
                                <TableRow hover key={index}>
                                  <TableCell component="th" scope="row">
                                    <div className={classes.author}>
                                      <Typography>
                                        {milestone.title}
                                      </Typography>
                                    </div>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography>
                                      {milestone.projectManagerFullName}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography>
                                      <DateTime value={milestone.startDate} date /*time*/ />
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography>
                                      <DateTime value={milestone.endDate} date /*time*/ />
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography>
                                      {getPhaseLabel(milestone.phaseId)}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography>
                                      {currencyFormatter(milestone.value)}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography style={{ display: 'flex', justifyContent: 'center' }}>
                                      {
                                        checkPM(milestone) ?
                                          <>
                                            {
                                              isDeletingMilestones !== milestone.milestoneId &&
                                              <Button
                                                color="primary"
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                  setMilestoneId(milestone.milestoneId);
                                                  setCanUser(true);
                                                }}
                                              >Edit</Button>
                                            }
                                          </> :
                                          <Button
                                            color="primary"
                                            size="small"
                                            variant="contained"
                                            onClick={() => {
                                              setMilestoneId(milestone.milestoneId);
                                              setCanUser(false);
                                            }}
                                          >View</Button>
                                      }
                                      {
                                        checkPM(milestone) &&
                                        <>
                                          {
                                            isDeletingMilestones === milestone.milestoneId ?
                                            <CircularProgress color="secondary" /> :
                                            <Button
                                              color="secondary"
                                              size="small"
                                              variant="contained"
                                              style={{ marginLeft: '20px' }}
                                              onClick={() => {
                                                if (window.confirm("Are you sure you want to delete this milestone?"))
                                                  sendDataAsync();

                                                async function sendDataAsync() {
                                                  setIsDeletingMilestones(milestone.milestoneId);
                                                  await props.deleteMilestoneAsync(milestone.milestoneId);
                                                  setIsDeletingMilestones(null);
                                                  resetFields();
                                                  getMilestonesAsync();
                                                }
                                              }}
                                            >
                                              Delete
                                            </Button>
                                          }
                                        </>
                                      }
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )}
                          </TableBody>
                          <TableFooter arial-label="role table">
                            <TableRow>
                              <TableCell className={classes.header} align="left">
                                Actual: {props.selectedProject && props.selectedProject[0] && currencyFormatter(props.selectedProject[0].actual)}
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                              </TableCell>
                              <TableCell className={classes.header} align="left">
                                {currencyFormatter(totalValue)}
                              </TableCell>
                              <TableCell align="right"></TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </div>
                    <div style={{ height: '15%', display: 'flex', justifyContent: 'center' }}>
                      {
                        props.isEditable &&
                        <div style={{ alignSelf: 'center', marginRight: '5%' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{ fontSize: '12px' }}
                            onClick={() => {
                              setMilestoneId(0);
                              setCanUser(true);
                            }}
                          >Add new milestone</Button>
                        </div>
                      }
                      <div style={{ alignSelf: 'center' }}>
                        <Button
                          variant="contained"
                          style={{ fontSize: '12px' }}
                          onClick={() => closeDialog()}
                        >Close</Button>
                      </div>
                    </div>
                  </div>
              }
            </DialogContent>
          </>
        }
      </Dialog>
    </span>
  );
}